import {useEffect} from "react";
import {isPageReload} from "@utils/is-page-reload";


/**
 * Runs the callback once on mount if the page was reached via a reload.
 */
export const useOnPageReload = (onReload: () => void): void => {
    useEffect(() => {
        if (isPageReload()) onReload();
    }, []);
};
